<template>
  <div class="sidebar-details">
    <div class="sidebar-details-header">
      <div class="sidebar-details-close" v-on:click="$store.dispatch('backDetails');">
        <i class="far fa-arrow-alt-circle-left"></i>
      </div>
      <div class="sidebar-details-main-title">{{ office.properties.nazwa | showInLang(currlang) }}</div>
    </div>
    <div class="sidebar-details-body">
      <div class="sidebar-details-image">
        <div @click="openLightbox">
          <b-carousel id="carousel2" controls :interval="2000" v-model="carouselIndex">
            <template v-for="(url, index) in CarouselImages">
              <b-carousel-slide :key="index" :img-src="url.path + '?thumb=1'" @click="openLightbox"></b-carousel-slide>
            </template>
          </b-carousel>
        </div>
      </div>

      <div class="sidebar-details-first-info">
        <div class="sidebar-details-area-label">{{ $t('nav.infoPanel.surface') }}</div>
        <div class="sidebar-details-area-value">
          {{ office.properties.pow_m2 | parseToIntM2 }}
          <sup>2</sup>
        </div>
      </div>

      <SidebarDetailsOptions
        panoramaUrl="$parent.panoramaUrl"
        @calc="$parent.openModalCalc()"
        :coordinates="this.office.geometry.coordinates"
      />

      <div class="sidebar-details-informations">
        <div class="sidebar-details-title">{{ $t("nav.halls.regData") }}</div>
        <table class="table sidebar-details-informations-table">
          <tbody>
            <tr>
              <td>{{ $t("nav.halls.hallName") }}</td>
              <td>{{ office.properties.nazwa | showInLang(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.address") }}</td>
              <td>{{ office.properties.adres | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.city") }}</td>
              <td>{{ office.properties.miejscowosc | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.communityName") }}</td>
              <td>{{ office.properties.gmina_nazwa | removeCommunityName | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.districtName") }}</td>
              <td>{{ office.properties.powiat_nazwa | showInLangField(currlang) }}</td>
            </tr>
            <tr>
              <td>{{ $t("nav.halls.voivodeshipName") }}</td>
              <td>{{ office.properties.wojewodztwo_nazwa | showInLangField(currlang) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sidebar-details-contact">
        <div class="sidebar-details-title">{{ $t("nav.offices.contactPerson") }}</div>
        <div class="sidebar-details-contact-item">
          <div
            class="sidebar-details-contact-avatar"
            v-if="office.properties.os_kontakt_avatar.length"
          >
            <img :src="$parent.imgToSrc(office.properties.os_kontakt_avatar)" />
          </div>
          <div v-else>{{ office.properties.os_kontakt_avatar | showInLangAvatar(currlang) }}</div>
          <div class="sidebar-details-contact-info">
            <div
              class="sidebar-details-contact-info-name"
            >{{ $t("nav.offices.contactPerson") }} {{ office.properties.os_kontakt | showInLangField(currlang) }}</div>
            <div class="sidebar-details-contact-info-phone">
              {{ $t("nav.offices.telFirst") }}
              <a
                :href="'tel:' + office.properties.os_kontakt_tel_sluzb"
              >{{ office.properties.os_kontakt_tel_sluzb | showInLangField(currlang) }}</a>
            </div>

            <div class="sidebar-details-contact-info-phone">
              {{ $t("nav.offices.telSecond") }}
              <a
                :href="'tel:' + office.properties.os_kontakt_tel_kom"
              >{{ office.properties.os_kontakt_tel_kom | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-mail">
              {{ $t("nav.offices.email") }}
              <a
                :href="'mailto:' + office.properties.os_kontakt_email"
              >{{ office.properties.os_kontakt_email | showInLangField(currlang) }}</a>
            </div>
            <div class="sidebar-details-contact-info-options">
              <div
                class="sidebar-details-contact-info-options-item pdf"
                v-tooltip.auto="$t('tooltip.savePDF')"
              >
                <img src="img/pdf_icon.svg" />
              </div>
              <div
                class="sidebar-details-contact-info-options-item qrcode"
                v-tooltip.auto="$t('tooltip.qrcode')"
                @click="$modal.show('qrcode-modal')"
              >
                <img src="img/qr_code_icon.svg" />
              </div>
              <div class="sidebar-details-contact-info-options-item degrees">
                <img src="img/question_mark_icon.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sidebar-details-informations">
        <div class="sidebar-details-ann">
          <div class="sidebar-details-ann-text">{{ $t("nav.infoPanel.add1") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarDetailsOptions from "./SidebarDetailsOptions";

export default {
  components: {
    SidebarDetailsOptions
  },
  data() {
    return {
      carouselIndex: 0,
    }
  },
  computed: {
    office() {
      return this.$store.getters.currentBiuro || { properties: {} };
    },
    currlang() {
      return this.$parent.currlang;
    },
    openLightbox() {
      return () => {this.$parent.openLightbox(this.office.properties.zdjecia, this.carouselIndex)};
    },
    CarouselImages() {
      let CarouselImages = [];
      let zdjecia = this.office.properties.zdjecia || [];
      if (zdjecia.length == 0) {
        CarouselImages.push({
          path: "img/invest_park_logo_big.png"
        });
      }
      zdjecia.forEach(pathImg => {
        CarouselImages.push({
          path: this.$parent.imgToSrc(pathImg)
        });
      });
      return CarouselImages;
    }
  }
};
</script>
